import { Body, Controller, Post } from '@nestjs/common';
import { AssociatesResponse, CompanyIdRequest, DepartmentDropResponse, ExcelImportResponse, GlobalResponseObject } from '@schemax-whatsapp/shared-models';
import { ExcelImportService } from './excel-import.service';
import { CompanyDeptRoleCategoryCodeRequest } from './model/company-dept-role-cat.request';
import { ExcelImportModel } from './model/excel-import.model';
import { WhatsappBroadCastService } from './whatsapp-broad-cast.service';
import { ApplicationExceptionHandler } from '@schemax-whatsapp/backend-utils';

@Controller('whatsapp-broad-cast')
export class WhatsappBroadCastController {
  applicationExceptionHandler: ApplicationExceptionHandler;
  constructor(
    private whatsappService: WhatsappBroadCastService,
    private excelImportService: ExcelImportService
  ) { }

  // ------------------------- EXCEL import ------------------

  @Post('/saveExcelData')
  async saveExcelData(@Body() req:ExcelImportModel[]): Promise<ExcelImportResponse> {
      try {
          return await this.excelImportService.saveExcelData(req);
      } catch (error) {
          return this.applicationExceptionHandler.returnException(ExcelImportResponse, error);
      }
  }

  @Post('/excelImportTableData')
  async excelImportTableData(): Promise<ExcelImportResponse> {
      try {
          return await this.excelImportService.excelImportTableData();
      } catch (error) {
          return this.applicationExceptionHandler.returnException(ExcelImportResponse, error);
      }
  }
}
